import { ChangeColor } from './ChangeColor';

export class ChangeLinkOnDarkColor extends ChangeColor {
  type: string = 'ChangeLinkOnDarkColor';
}
